import { render } from "./CustumTextArea.vue?vue&type=template&id=0087d98c"
import script from "./CustumTextArea.vue?vue&type=script&lang=js"
export * from "./CustumTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__